module.exports = __webpack_public_path__ + "img/202412_04.929d8424.jpg";